window.TEV_COPY = {
  labels: {
    tool_title: "EV Fit & Cost Compare",
    mode_ev_vs_ice: "EV vs petrol/diesel",
    mode_ev_vs_ev: "EV vs EV",
    mode_find_my_ev: "Find My EV",
    period_label: "Ownership period",
    annual_mileage_label: "Annual mileage"
  },

  badges: {
    best_first_ev: "Best first EV",
    best_value_used: "Best value used",
    best_city: "Best for city",
    best_motorway: "Best for motorway",
    best_family: "Best family fit"
  },

  messages: {
    disclaimer:
      "Estimates only. Real-world costs vary by driving style, tariff, route, weather, specification and market pricing.",
    comparison_note:
      "Compared using selected mileage, UK assumptions and same-class matching logic.",
    uncertainty_10y:
      "10-year estimates carry greater uncertainty and should be treated as directional."
  }
};